import React from 'react'

function SystemStatus() {
  return (
    <div>SystemStatus</div>
  )
}

export default SystemStatus